import { Transport } from "../../common/model/transport.model";
import { TransportOptionSelection } from '../transport-options-panel/transport-options-panel.model';

export class EditTransport {

  transport: Transport = new Transport();

  optionsChanged: boolean = false;
  updateRouting: boolean = false;
  updateRoutingPossible: boolean = false;
  registerEntranceEnabled: boolean = false;
  inPlanningMode: boolean = false;
  registerNow: boolean = false;
  restartRouting: boolean = false;
  restartRoutingPossible: boolean = false;

  selectedOptions = new Array<TransportOptionSelection>();

  constructor(edit?: any) {
    if (edit != null) {

      this.optionsChanged = edit.optionsChanged;
      this.updateRouting = edit.updateRouting;
      this.updateRoutingPossible = edit.updateRoutingPossible;
      this.registerEntranceEnabled = edit.registerEntranceEnabled;
      this.inPlanningMode = edit.inPlanningMode;
      this.restartRouting = edit.restartRouting;
      this.restartRoutingPossible = edit.restartRoutingPossible;
      this.registerNow = edit.registerNow;

      if (edit.transport != null) {
        this.transport = new Transport(edit.transport);
      }

      if (edit.selectedOptions != null) {
        for (const option of edit.selectedOptions) {
          this.selectedOptions.push(new TransportOptionSelection(option));
          
          if (option.transportOptions != null) {
            for (const suboption of option.transportOptions) {
              this.selectedOptions.push(new TransportOptionSelection(suboption));
            }
          }
        }
      }

    }
  }

}
